import { render, staticRenderFns } from "./InputCurrency.vue?vue&type=template&id=08857d88&"
import script from "./InputCurrency.vue?vue&type=script&lang=js&"
export * from "./InputCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\MasterBranches\\Maintenance_06.04\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08857d88')) {
      api.createRecord('08857d88', component.options)
    } else {
      api.reload('08857d88', component.options)
    }
    module.hot.accept("./InputCurrency.vue?vue&type=template&id=08857d88&", function () {
      api.rerender('08857d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Wes/InputCurrency.vue"
export default component.exports